// SPDX-License-Identifier: AGPL-3.0-or-later

import {useEffect, useState} from 'react';

// The time for a turn clock, redrawn every `everyMs` while it runs; nothing ticks on a stopped clock. Only the part that
// shows the clock calls it, so a tick redraws that clock and never the board around it.
export function useClockNow(running: boolean, everyMs: number): number {
	const [, setTick] = useState(0);
	useEffect(() => {
		if (!running) return;
		const timer = setInterval(() => setTick((tick) => tick + 1), everyMs);
		return () => clearInterval(timer);
	}, [running, everyMs]);
	return Date.now();
}
